module.exports = __webpack_public_path__ + "static/media/instructivom1.5e69f6c2.png";